let fromValue: string = null;

export const setFrom = (from: string) => fromValue = from;

export const getFrom = () => fromValue;